import { render, staticRenderFns } from "./WithDebts.vue?vue&type=template&id=480808d4&scoped=true&"
import script from "./WithDebts.vue?vue&type=script&lang=ts&"
export * from "./WithDebts.vue?vue&type=script&lang=ts&"
import style0 from "./WithDebts.vue?vue&type=style&index=0&id=480808d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480808d4",
  null
  
)

export default component.exports